
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/referral-program",
      function () {
        return require("private-next-pages/legal/referral-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/referral-program"])
      });
    }
  